<div class="row">
    <div class="col-xl-9 mb-4">

    </div>
    <div class="col-xl-3 mb-4 ct_mt_top_68">

        <div class="ct_right_sidebar">
            <div class="mb-4">
                <div *ngIf="selectedFacility">
                    <p-dropdown class="ct_select_op_input ct_chev_icon_dark230" required #country="ngModel"
                        [options]="dashboardData" optionLabel="AssestType" optionValue="ID"
                        [(ngModel)]="selectedFacility" [ngModelOptions]="{standalone: true}" [scrollable]="true"
                        (onChange)="onFacilityChange($event)">
                        <ng-template let-option pTemplate="item">
                            <div class="d-flex justify-content-between">
                                <div>{{ option.AssestType }}</div>
                                <div class="d-flex justify-content-end pt-1 ml-1">
                                    <i class="fa" [class.fa-users]="isArray(option.ID)"
                                        [class.fa-user]="!isArray(option.ID)"></i>
                                </div>
                            </div>
                        </ng-template>
                    </p-dropdown>
                    <div class="mt-4">
                        <p class="mb-1 ct_fw_500">Calendar Year</p>
                        <p-calendar class="w-100 ct_input_dark_text_145" [(ngModel)]="year" ngModel name="year" year
                            view="year" dateFormat="yy" inputId="yearpicker" styleClass="pcalender"
                            (ngModelChange)="onFacilityChange($event)" [showIcon]="true"></p-calendar>
                        <!-- <select class="ct_period_select w-100">
                            <option value="">2023-2024</option>
                            <option value="">2023-2024</option>
                        </select> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="row">
    <div class="col-md-12">
        <div class="row">

            <div class="col-xl-4 mb-4">
                <div class="ct_grey_border_1 ">
                    <div class="ct_d_flex_1 ct_grey_brdr_btm1 pb-3 mb-3">
                        <div>
                            <h5 class="ct_font_16">Stationary Combustion</h5>
                            <h3 class="ct_fs_24">{{airTotal | number:'1.3-3'}}</h3>
                            <p class="mb-0">tCO2e</p>
                        </div>

                    </div>
                    <div id="ct_emission_by_travel" *ngIf="donotOptions1">
                        <apx-chart [series]="donotOptions1.series" [chart]="donotOptions1.chart"
                            [labels]="donotOptions1.labels" [legend]="donotOptions1.legend"
                            [colors]="donotOptions1.colors" [responsive]="donotOptions1.responsive"></apx-chart>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 mb-4">
                <div class="ct_grey_border_1">
                    <div class="ct_d_flex_1 ct_grey_brdr_btm1 pb-3 mb-3">
                        <div>
                            <h5 class="ct_font_16">Emissions in Electricity use</h5>
                            <h3 class="ct_fs_24">{{renewableTotal}}</h3>
                            <p class="mb-0">KWH</p>
                        </div>

                    </div>
                    <div id="By_employee_location" *ngIf="pieChart">
                        <apx-chart [series]="pieChart.series" [chart]="pieChart.chart" [labels]="pieChart.labels"
                            [legend]="pieChart.legend" [responsive]="pieChart.responsive"
                            [colors]="pieChart.colors"></apx-chart>
                    </div>
                </div>
            </div>
            <div class="col-xl-4 mb-4">
                <div class="ct_grey_border_1" *ngIf="donotOptions2">
                    <div class="ct_d_flex_1 ct_grey_brdr_btm1 pb-3 mb-3">
                        <div>
                            <h5 class="ct_font_16">WTT Emissions</h5>
                            <h3 class="ct_fs_24">{{activityTotal | number:'1.3-3' }}
                            </h3>
                            <p class="mb-0">tCO2e</p>
                        </div>

                    </div>
                    <apx-chart [series]="donotOptions2.series" [chart]="donotOptions2.chart"
                        [labels]="donotOptions2.labels" [fill]="donotOptions2.fill" [colors]="donotOptions2.colors"
                        [legend]="donotOptions2.legend" [dataLabels]="donotOptions2.dataLabels"
                        [responsive]="donotOptions2.responsive"></apx-chart>
                </div>

            </div>
            <div class="col-xl-12 mb-12">
                <div class="ct_grey_border_1 ">
                    <div class="ct_d_flex_1 ct_grey_brdr_btm1 pb-3 mb-3">
                        <div>
                            <h5 class="ct_font_16">Emissions by Month</h5>
                            <!-- <p class="mb-0">FY 2023-2024</p> -->
                        </div>

                    </div>
                    <div id="ct_emission_by_month" *ngIf="chartOptions">
                        <apx-chart [series]="chartOptions.series" [chart]="chartOptions.chart"
                            [dataLabels]="chartOptions.dataLabels" [plotOptions]="chartOptions.plotOptions"
                            [yaxis]="chartOptions.yaxis" [legend]="chartOptions.legend" [fill]="chartOptions.fill"
                            [stroke]="chartOptions.stroke" [tooltip]="chartOptions.tooltip"
                            [xaxis]="chartOptions.xaxis"></apx-chart>
                    </div>
                </div>
            </div>

        </div>

    </div>